import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import List from 'components/v2/List'
import { DotsIcon } from 'components/Icons/DotsIcon'
import Dropdown from 'components/v2/Dropdown'
import { ArchiveInventoryModal } from 'features/Inventories/components/ArchiveInventoryModal'
import { TYPE } from 'features/Inventories/components/Type/constants'
import { canWriteBase, canWriteWarehouse } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'
import { GTInventory } from 'gql/types.generated'
import IconButton from 'components/v2/IconButton'

export const InventoriesActions = ({ inventory }: { inventory: GTInventory }): ReactElement => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)
  const [isOpenArchiveInventoryModal, setIsOpenArchiveInventoryModal] = useState(false)

  const login = useLogin()

  const toggleDropdown = (): void => {
    setOpenDropdown(!isOpenDropdown)
  }

  const canWrite =
    (inventory.type === TYPE.BASE && canWriteBase(login.accessToken.policies)) ||
    (inventory.type === TYPE.WAREHOUSE && canWriteWarehouse(login.accessToken.policies))

  const handleArchiveAction = (): void => {
    if (canWrite) {
      setOpenDropdown(false)
      setIsOpenArchiveInventoryModal(true)
    }
  }

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): void => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator left>
          <List.Container>
            <List.Item action noPadding={canWrite} disabled={!canWrite}>
              {canWrite ? (
                <List.Link to={`/inventories/${inventory.id}`}>
                  <FormattedMessage id="spanish.inventories.list.actions.edit" defaultMessage="Editar inventario" />
                </List.Link>
              ) : (
                <FormattedMessage id="spanish.inventories.list.actions.edit" defaultMessage="Editar inventario" />
              )}
            </List.Item>
            <List.Item action noPadding={canWrite} disabled={!canWrite}>
              {canWrite ? (
                <List.Link to={`/inventories/${inventory.id}/receive-bulk-items`}>
                  <FormattedMessage
                    id="spanish.inventories.list.actions.receiveProducts.label"
                    defaultMessage="Entrada"
                  />
                </List.Link>
              ) : (
                <FormattedMessage
                  id="spanish.inventories.list.actions.receiveProducts.label"
                  defaultMessage="Entrada"
                />
              )}
            </List.Item>
            <List.Item action noPadding={canWrite} disabled={!canWrite}>
              {canWrite ? (
                <List.Link to={`/inventories/${inventory.id}/remove-bulk-items`}>
                  <FormattedMessage
                    id="spanish.inventories.list.actions.removeProducts.label"
                    defaultMessage="Salida"
                  />
                </List.Link>
              ) : (
                <FormattedMessage id="spanish.inventories.list.actions.removeProducts.label" defaultMessage="Salida" />
              )}
            </List.Item>
            <List.Item action disabled={!canWrite} onClick={handleArchiveAction}>
              <FormattedMessage id="spanish.inventories.list.actions.archive.label" defaultMessage="Archivar" />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
      {isOpenArchiveInventoryModal && (
        <ArchiveInventoryModal inventory={inventory} closeModal={(): void => setIsOpenArchiveInventoryModal(false)} />
      )}
    </>
  )
}
